import React, { useEffect } from 'react';
import { hasNoPaymentCards } from '../../../utils/payments';
import { Spinner } from '../../shared/spinner/spinner';
import { usePayments } from '../../../hooks/use-payments';
import { ProXtraDollarCard } from '../proxtra-dollars-card/proxtra-dollars-card';
import { CardType } from '../../../constants/payments';
import { PaymentsHeader } from '../payments-header/payments-header';
import { TAlertStatus } from '../../../models/common/alert-messages';
import { Alert } from '../../shared/alert/alert';
import { Pagination } from '../../shared/pagination/pagination';
import { scrollToTop } from '../../../utils/general';
import { NoPaymentCardsMessage } from '../../shared/no-payment-cards-message/no-payment-cards-message';

export const ProXtraDollarsList = () => {
  const {
    loading,
    proXtraDollarCards,
    alertMessage,
    paginationInfo,
    currentPageNumber,
    getPaymentCards,
    setAlertMessage,
  } = usePayments();

  const totalPages = Number(paginationInfo?.totalPages) || 0;

  useEffect(() => {
    return () => {
      setAlertMessage(null);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const resetAlert = () => {
    setAlertMessage(null);
  };

  const onChangePage = (page: number) => {
    getPaymentCards(CardType.PRO_XTRA_DOLLARS, false, false, {
      page,
    });
  };

  const displayAlertMessage = alertMessage &&
    (alertMessage.alertStatus === TAlertStatus.ERROR ||
      alertMessage.alertStatus === TAlertStatus.SUCCESS) && (
      <div className="sui-mb-8">
        <Alert status={alertMessage.alertStatus} onClose={resetAlert}>
          {alertMessage.text}
        </Alert>
      </div>
    );

  return (
    <>
      <Spinner active={loading} />
      <PaymentsHeader
        cardType={CardType.PRO_XTRA_DOLLARS}
        onActionFailure={() => null}
        onActionSuccess={() => null}
      />
      {displayAlertMessage}
      {hasNoPaymentCards(proXtraDollarCards) && (
        <NoPaymentCardsMessage tenderType={CardType.PRO_XTRA_DOLLARS} />
      )}
      <div className="sui-grid sui-grid-cols-1 sui-gap-y-8 sui-gap-x-8 md:sui-grid-cols-2 2xl:sui-gap-y-16 2xl:sui-grid-cols-3">
        {proXtraDollarCards?.paymentCards.map((card) => (
          <ProXtraDollarCard key={card.paymentId} card={card} />
        )) || null}
      </div>
      {totalPages > 1 && (
        <div className="sui-w-full sui-justify-center sui-p-5 sui-flex">
          <Pagination
            nPages={totalPages}
            onChangePage={(newPage) => {
              onChangePage(newPage);
              setAlertMessage(null);
              scrollToTop();
            }}
            page={currentPageNumber}
          />
        </div>
      )}
    </>
  );
};
